import { WaterbodyDetail } from '@omniafishing/core';
import React from 'react';
import { useFrontload } from 'react-frontload';
import { apiV1 } from '../../lib/api';
import { WaterbodyFishingPatternsPage } from './waterbody_fishing_patterns_page';

interface WaterbodyCurrentConditionsPageProps {
  lastUpdatedISODate: string;
  waterbodyDetail: WaterbodyDetail;
}

export const WaterbodyFishingPatternsPageContainer = (
  props: WaterbodyCurrentConditionsPageProps
) => {
  const { waterbodyDetail, lastUpdatedISODate } = props;

  const { url_slug } = waterbodyDetail;

  const { data, frontloadMeta } = useFrontload(
    `WaterbodyFishingPatternsPageContainer:${url_slug}`,
    async () => {
      try {
        const [keyForageRes, seasonalBaitColorsRes, seasonalPatternsRes, seasonalStructureRes] =
          await Promise.allSettled([
            apiV1.waterbodySummariesKeyForageFetch(url_slug, {
              version: 'v1',
              model: 'flavorful-lunker',
            }),
            apiV1.waterbodySummariesSeasonalBaitColorsFetch(url_slug, {
              version: 'v1',
              model: 'flavorful-lunker',
            }),
            apiV1.waterbodySummariesSeasonalPatternsFetch(url_slug, {
              version: 'v2',
              model: 'flavorful-lunker',
            }),
            apiV1.waterbodySummariesSeasonalStructureFetch(url_slug, {
              version: 'v1',
              model: 'flavorful-lunker',
            }),
          ]);

        const key_forage =
          keyForageRes.status === 'fulfilled' ? keyForageRes.value.data.data : null;
        const seasonal_bait_colors =
          seasonalBaitColorsRes.status === 'fulfilled'
            ? seasonalBaitColorsRes.value.data.data
            : null;
        const seasonal_patterns =
          seasonalPatternsRes.status === 'fulfilled' ? seasonalPatternsRes.value.data.data : null;
        const seasonal_structure =
          seasonalStructureRes.status === 'fulfilled' ? seasonalStructureRes.value.data.data : null;

        return {
          summary: {
            key_forage,
            seasonal_bait_colors,
            seasonal_patterns,
            seasonal_structure,
          },
        };
      } catch (e) {
        console.log(e);
      }
    }
  );

  if (!data || !frontloadMeta.done) {
    return null;
  }

  return (
    <WaterbodyFishingPatternsPage
      waterbodyDetail={waterbodyDetail}
      summary={data?.summary}
      lastUpdatedISODate={lastUpdatedISODate}
    />
  );
};
